import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastService } from '@northfork/ng-basics'
import {
  TransactionTypeLabel,
  TransactionTypeLabelRequest,
} from '../../models/transaction-type-labels.model'
import { EditTransactionTypeLabelService } from '../../services/edit-transaction-type-label.service'

@Component({
  selector: 'hs-transaction-type-label',
  templateUrl: './edit-transaction-type-label.component.html',
  styleUrls: ['./edit-transaction-type-label.component.scss'],
})
export class EditTransactionTypeLabelComponent implements OnInit {
  @Input() transactionIds?: string[]
  @Input() transactionLabel?: string
  select = new FormControl()
  isLabelSelected = false
  typeLabel: TransactionTypeLabel[] = []
  formSubmitting = false
  labelLoaded = false

  constructor(
    public activeModal: NgbActiveModal,
    public toastService: ToastService,
    readonly editTransactionTypeLabelService: EditTransactionTypeLabelService,
  ) {}
  async ngOnInit() {
    this.init()
  }
  init() {
    this.loadTransactionLabel()
  }
  async loadTransactionLabel() {
    this.labelLoaded = true
    this.editTransactionTypeLabelService
      .getTranTypeLabel()
      .subscribe(labels => {
        this.typeLabel = Object.entries(labels).map(([id, name]) => ({
          id: Number(id),
          name: name,
        }))
        this.handleLabel()
        this.labelLoaded = false
      })
  }
  handleLabel() {
    this.typeLabel.forEach((label: TransactionTypeLabel) => {
      if (
        this.transactionLabel !== undefined &&
        this.transactionLabel === label.name
      ) {
        this.select.patchValue(label)
        this.isLabelSelected = true
      }
    })
  }
  save() {
    const requestBody = {
      transactionIds: this.transactionIds,
      transactionTypeLabelId: this.select.value.id,
    } as TransactionTypeLabelRequest
    this.formSubmitting = true
    this.editTransactionTypeLabelService
      .saveTransactionLabel(requestBody)
      .subscribe(
        () => {
          this.toastService.success(
            'Edit transaction type label command is successfully submitted.',
          )
          this.formSubmitting = false
          this.activeModal.close()
        },
        () => {
          this.toastService.error(
            'Edit transaction type label command submission failed.',
          )
          this.formSubmitting = false
        },
      )
  }
  onChange() {
    this.isLabelSelected = this.select.value ? true : false
  }
}
